import React, { useEffect } from "react";
import { UseApi } from "../../hooks/use-api";
import { GetProduct } from "../../Services/lib/nft";
import Card from "../Card";
import Loader from "../Loader";
import Tabs from "../Tabs";
import NFTList from "./NFTlist";
import PrimaryBuyers from "./PrimaryBuyers";
import styles from "./Product.module.sass";
import cn from "classnames";
import { useUser } from "../../context";
import nft_product from "../../i11/Nft_Product";
import { Bids } from "./Auction";

const Product = ({ data: id, nfts, type }) => {
	const { locale } = useUser();
	const [{ data, isLoading }, getProduct] = UseApi({
		service: GetProduct,
	});

	useEffect(() => {
		if (id) {
			getProduct(id);
		}
	}, [id]);

	return (
		<Card title={nft_product[locale].product} classTitle="title-green">
			{isLoading || !data ? (
				<div className={styles.loaderWrap}>
					<Loader className={styles.loader} />
				</div>
			) : (
				<div className={styles.container}>
					<div className={styles.top}>
						<div className={styles.img}>
							<img src={data.image} alt={data.name} />
						</div>
						<Top data={data} />
					</div>
					<div className={cn("title", styles.opacity)}>
						{nft_product[locale].description}
					</div>
					<div className={styles.description}>{data.description}</div>
					<Tabs
						default_={
							nfts ? (type === "AUCTION_EDITION" ? 2 : 1) : 0
						}
						head={
							type === "AUCTION_EDITION"
								? [
										nft_product[locale].nftlist,
										nft_product[locale].direct_pur,
										nft_product[locale].bid_list,
								  ]
								: [
										nft_product[locale].nftlist,
										nft_product[locale].direct_pur,
								  ]
						}
						body={[
							<NFTList ProductId={data._id} />,
							<PrimaryBuyers item={data} />,
							<Bids nftId={data._id} />,
						]}
					/>
				</div>
			)}
		</Card>
	);
};

const Type = {
	LIMITED_EDITION: "LIMITED",
	AUCTION_EDITION: "SINGLE",
	SINGLE_EDITION: "SINGLE",
};

const Top = ({ data }) => {
	const { locale } = useUser();
	return (
		<div className={styles.topLeft}>
			<div>{nft_product[locale].name}</div>
			<div className="title">{data.name}</div>

			<div className={styles.topRow}>
				<div>
					<div className={styles.statistic}>
						<div className={styles.opacity}>
							{nft_product[locale].direct_price}
						</div>
						<div className={styles.opacity}>
							{/* Community market floor price */}
						</div>
						<div>
							{data.price} {data.currency}
						</div>
						<div>{/* - - - - - */}</div>
					</div>
					<div className={styles.statistic}>
						<div className={styles.opacity}>
							{nft_product[locale].type_count}
						</div>
						<div className={styles.opacity}>{/* Owners */}</div>
						<div>
							<div className={styles.type}>{Type[data.type]}</div>{" "}
							/{" " + data.totalNFTs}
						</div>
						<div>{/* {data.countNFTs} */}</div>
					</div>
				</div>
				<div>
					<div className={styles.statistic}>
						<div className={styles.opacity}>
							{nft_product[locale].token_id}
						</div>
						<div className={styles.opacity}></div>
						<div>{data.smartContract}</div>
						<div>{/* - - - - - */}</div>
					</div>
					<div className={styles.statistic}>
						<div className={styles.opacity}>
							{nft_product[locale].token_type}
						</div>
						<div className={styles.opacity}>{/* Owners */}</div>
						<div>
							{/* <div className={styles.type}>{Type[data.type]}</div> */}
							{data.tokenType}
						</div>
						<div>{/* {data.countNFTs} */}</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Product;
